export default {
  data () {
    return {
      w: window,
      stickyDatas: {
        posTop: undefined,
        parentEl: undefined,
        stickyEl: undefined,
        scrollEl: undefined,
        scrollFullscreenEl: undefined,
        ticking: false
      },
      stickyStyles: {
        top: ''
      }
    }
  },
  watch: {
    isLoading () {
      this.tickingSticky()
    },
    fullscreen () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.tickingSticky() // Calcul stats-header sticky
        }, 250)
      })
    }
  },
  methods: {
    calculsSticky () {
      // Capturer la position TOP que l'on doit donner au header stats sticky
      let posTop = this.stickyDatas.parentEl.getBoundingClientRect().top
      // Recuperation de la position du scroll
      let scrollY = this.getPosScrollY()
       // On aditionne avec le scroll pour que la position sticky soit tjr bonne mm apres resize du navigateur
      posTop = posTop + scrollY
      // console.log('posTop + scrollY', posTop)
      // Calcul de la position top avec ou sans padding suivant si fullscreen ou non
      posTop = (this.fullScreen) ? posTop + 'px' : 'calc(' + posTop + 'px - 1.5em)' // 1.5em padding-top du parent
      // Memorisation de la position top (pour le style)
      this.$set(this.stickyStyles, 'top', posTop)
    },
    initSticky () {
      let parentEl = this.$el.querySelector('div[data-sticky-pos-top="headerStats"]')
      let stickyEl = parentEl.querySelector('.stat-header--sticky')
      let scrollEl = document.getElementById('app')
      let scrollFullscreenEl = document.getElementById('layout')
      if (parentEl !== undefined && stickyEl !== undefined) {
        this.$set(this.stickyDatas, 'parentEl', parentEl)
        this.$set(this.stickyDatas, 'stickyEl', stickyEl)
        this.$set(this.stickyDatas, 'scrollEl', scrollEl)
        this.$set(this.stickyDatas, 'scrollFullscreenEl', scrollFullscreenEl)
        this.tickingSticky()
        // Events
        this.w.addEventListener('resize', this.tickingSticky)
        this.stickyDatas.scrollEl.addEventListener('scroll', this.tickingSticky)
        this.stickyDatas.scrollFullscreenEl.addEventListener('scroll', this.tickingSticky)
      }
    },
    tickingSticky () {
      if (!this.stickyDatas.ticking) {
        this.w.requestAnimationFrame(() => {
          this.calculsSticky()
          this.$set(this.stickyDatas, 'ticking', false)
        })
        this.$set(this.stickyDatas, 'ticking', true)
      }
    },
    getPosScrollY () {
      // Retourne le scroll engagé suivant si l'on est en fullscreen ou non
      if (!this.fullscreen) {
        return this.stickyDatas.scrollEl.pageYOffset || this.stickyDatas.scrollEl.scrollTop
      } else {
        return this.stickyDatas.scrollFullscreenEl.pageYOffset || this.stickyDatas.scrollFullscreenEl.scrollTop
      }
    },
    destroySticky () {
      this.w.removeEventListener('resize', this.tickingSticky)
      this.stickyDatas.scrollEl.removeEventListener('scroll', this.tickingSticky)
      this.stickyDatas.scrollFullscreenEl.removeEventListener('scroll', this.tickingSticky)
      this.stickyStyles.top = ''
      this.stickyDatas.ticking = false
    }
  },
  mounted () {
    this.initSticky()
  },
  destroyed () {
    this.destroySticky()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/StatsStickyMixin.js